<template>
  <DnRouterLink
    title="Start Claim"
    url="/claimsAndReturns/createClaim"
  />
</template>

<script>
  import DnRouterLink from "@/components/Elements/DnRouterLink"
  export default {
    components: {
      DnRouterLink
    }
  }
</script>
